import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { MetersController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { Model as platformModel, EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist";

/**
 * MetersControllerGame class handles the meters for the base game
 *  ex. win meter, win tickup etc.
 */
export class MetersControllerGame extends MetersController {

  protected subscribeEvents(): void {
    super.subscribeEvents();
    // dispatcher.on(eventDispatchers.UPDATE_TICKUP_WIN_METER, this.setTickupWinValue, this);
    dispatcher.on(eventDispatchers.STOP_WIN_TICK_UP, this.stopRunningTickup, this);
  }

  // private setTickupWinValue(evt: IEvent): void {
  //   const duration = 0.8;
  //   const value = evt.data.value;
  //   let isValueInCredit = true;
  //   if (value === 0) {
  //     dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
  //   }
  //   if (isValueInCredit) {
  //     this.winValueMeter?.startTick(value, true, false, duration, true, () => { });
  //   } else {
  //     const converAmountToCoinFromCurrency = Math.round(Number(value) / ingenuity.configData.currentCoinValue).toString();
  //     this.winValueMeter?.setCoinFormattedValueToDecimal(converAmountToCoinFromCurrency, 0);
  //   }
  // }
  private stopRunningTickup():void{
    if (this.winValueMeter.getIsTickUpRunning()) {
      this.winValueMeter.stopTick();
    }
  }
  /**
   * This method is use to skip cascade animation on stage click
   */
  protected onForceStopWinTickUp(evt?: IEvent): void {
    if (ingenuity.configData.stageClickOnCascade) {
      if (this.winValueMeter.getIsTickUpRunning()) {
        this.winValueMeter.forceStop(this.model.getIsCredits(), false, true);
      }
      dispatcher.fireEvent(eventDispatchers.START_NEXT_CASCADE);
    } else {
      super.onForceStopWinTickUp();
    }
  }

  /**
   * Overrided to blank function in case of cascade
   */
  protected updateBalance(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
      //
    } else {
      super.updateBalance();
    }
  }

  protected onReturningFreegameUpdateMeter(evt: any): void {
    super.onReturningFreegameUpdateMeter(evt);
    (ingenuity.parserModel as GameParserModel).setIsFreeSpintriggered(false);
    // Win value converted to string as behaviour string to check when to show the win meter.
    const totalWin: string = (
      (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as platformModel).getFreeSpinTotalWin() + (ingenuity.parserModel as GameParserModel).getMoneyAndClueBasegameWin()
    ).toString();
    dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: totalWin });
    // dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, { value: totalWin, });
    (ingenuity.parserModel as GameParserModel).getPromotionalFreeGame() &&
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, true);
  }

  // Overrided to change tickup value as per current cascade win
  protected onStartWinTickUp(evt: IEvent): void {
    let a;
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    (a = this.winValueMeter) === null || a === void 0
      ? void 0
      : a.startTick(
        (ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin(),
        this.model.getIsCredits(),
        false,
        this.model.getWinMeterTickUpDuration(),
        true,
        this.updateBalance.bind(this)
      );
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: this.model.getWinMeterTickUpSound() });
    this.fadeBaseGameBGM();
  }
}
